import React from 'react';
import styled from 'styled-components';

const A1Style = styled.svg``;

export const A1 = ({ color }) => {
	return (
		<A1Style
			xmlns='http://www.w3.org/2000/svg'
			width='16.855'
			height='24.987'
			viewBox='0 0 16.855 24.987'
		>
			<path
				id='Leaf'
				d='M324.814,525.287A7.97,7.97,0,0,1,319.122,518c-.157-4.061,2.054-6.586,4.5-9.3a24.843,24.843,0,0,0,3.112-3.932.948.948,0,0,1,1.283-.348,1.1,1.1,0,0,1,.341.348l.007.021a25.563,25.563,0,0,0,3.106,3.911c2.444,2.723,4.662,5.255,4.491,9.3a7.952,7.952,0,0,1-5.693,7.283,9.174,9.174,0,0,1-2.156.375v.021a3.636,3.636,0,0,1-3.6,3.6.567.567,0,0,1,0-1.133,2.494,2.494,0,0,0,2.478-2.471v-.021a9.351,9.351,0,0,1-2.17-.375Zm-1.338-7.6h0a.577.577,0,0,1,0-.805.56.56,0,0,1,.792,0l2.716,2.709v-8.586a.563.563,0,1,1,1.126,0v5.959l2.7-2.7a.565.565,0,0,1,.8.8l-3.5,3.508v5.214a7.412,7.412,0,0,0,1.617-.294,6.09,6.09,0,0,0,4.368-5.549c.137-3.44-1.945-5.665-4.02-7.986a34.959,34.959,0,0,1-2.525-3.017,35.414,35.414,0,0,1-2.539,3.017c-2.075,2.321-4.157,4.545-4.013,7.986a6.083,6.083,0,0,0,4.361,5.549,7.471,7.471,0,0,0,1.624.287v-2.594l-3.508-3.494Z'
				transform='translate(-319.114 -504.3)'
				fill={color}
			/>
		</A1Style>
	);
};
